module.exports = __webpack_public_path__ + "static/media/iconCustomersupport.c382429b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/iconCustomersupport.svg
// module id = 142
// module chunks = 1